export const SESSION_ROOM_METHOD_OPEN = "SESSION_ROOM_METHOD_OPEN";
export const SESSION_ROOM_METHOD_CLOSE = "SESSION_ROOM_METHOD_CLOSE";

export const SESSION_ROOM_LEAVE_TRUE = "SESSION_ROOM_LEAVE_TRUE";
export const SESSION_ROOM_LEAVE_FALSE = "SESSION_ROOM_LEAVE_FALSE";

export const SMVM_SET_END_SESSION_REQUEST = "SMVM_SET_END_SESSION_REQUEST";
export const SMVM_SET_END_SESSION_SUCCESS = "SMVM_SET_END_SESSION_SUCCESS";
export const SMVM_SET_END_SESSION_FAIL = "SMVM_SET_END_SESSION_FAIL";
export const SMVM_SET_END_SESSION_RESET = "SMVM_SET_END_SESSION_RESET";
